import logo from './logo.svg';
import './App.css';
import PasswordChecker from './components/Password';

function App() {
  return (
    <div className="App">
      <PasswordChecker />
    </div>
  );
}

export default App;
